import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadDialogComponent } from './file-upload-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MeddataThemeModule } from '@meddatacore/ui';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [FileUploadDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MeddataThemeModule,
    MatProgressBarModule,
    MatDividerModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule.forChild()
  ],
  exports: [
    FileUploadDialogComponent
  ]
})
export class FileUploadDialogModule { }
